import request from '@/utils/request'

export function getClassRoomList(params) {
  return request({
    url: '/api/v1/teachers/lessonList',
    method: 'get',
    params
  })
}
export function getStudentReviews(params) {
  return request({
    url: '/api/v1/reviews/getStudentReviewsPage',
    method: 'get',
    params
  })
}
export function saveReviews(params) {
  return request({
    url: '/api/v1/reviews/saveReviews',
    method: 'get',
    params
  })
}

export function getWallet(params) {
  return request({
    url: '/api/v2/wallet/getWallet',
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/classRoom.js